import { useEffect } from 'react'
import { createPortal } from 'react-dom'

interface Props {
  header: React.ReactNode
  footer: React.ReactNode
  children: React.ReactNode
}

export function MobileModal({ header, footer, children }: Props) {
  useEffect(() => {
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return createPortal(
    <div
      style={{ paddingBottom: 220, top: 51 }}
      className="fixed inset-0 bg-white w-full h-full overflow-scroll flex flex-col z-50"
    >
      <div className="p-2 bg-gray-50 flex flex-col border">{header}</div>
      <div className="p-2">{children}</div>
      <div className="p-2 py-2 bg-gray-50 mt-auto w-full fixed bottom-[60px]">
        {footer}
      </div>
    </div>,
    document.body
  )
}
